import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUps = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 16,
			fill: "#351C15"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_68_10173)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M16.0002 27C15.469 26.7625 11.2171 24.9322 9.84461 23.7906C9.10885 23.1799 8.52254 22.409 8.13055 21.5368C7.73856 20.6647 7.55129 19.7144 7.58305 18.7587V8.86656C9.91774 7.62594 12.7431 7 16.0002 7C19.2574 7 22.0681 7.62937 24.4174 8.86656V18.7478C24.483 20.6853 23.6496 22.5441 22.1593 23.7834C20.8093 24.8813 16.5087 26.7772 16.0146 26.9928L16.0002 27Z",
				fill: "#FFB500"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M19.2382 15.3295C19.2472 14.8171 19.4584 14.3291 19.8259 13.9719C20.1934 13.6147 20.6873 13.4174 21.1998 13.423C21.7728 13.3929 22.3387 13.5608 22.8026 13.8986V15.1686C22.4566 14.8098 21.9869 14.5967 21.4888 14.5717C21.0754 14.5717 20.6435 14.7511 20.6288 15.2708C20.6141 15.7905 21.046 16.0026 21.5913 16.332C22.8132 17.0639 23.0551 17.6933 23.0226 18.5461C23.0179 19.092 22.7876 19.6086 22.3863 19.982C21.9851 20.3555 21.4482 20.5398 20.9038 20.5008C20.3366 20.4961 19.781 20.3408 19.2935 20.0508V18.7114C19.6798 19.0609 20.172 19.2709 20.6916 19.308C20.921 19.338 21.1519 19.2642 21.321 19.1058C21.4901 18.9473 21.5804 18.7226 21.566 18.4917C21.566 18.0342 21.2951 17.7817 20.6548 17.3939C19.4507 16.6876 19.231 16.1058 19.231 15.3261L19.2382 15.3295ZM15.6957 14.7076C15.8583 14.6364 16.0341 14.6002 16.2116 14.6014C17.0607 14.6014 17.4116 15.2786 17.4116 16.918C17.4116 18.5573 17.0091 19.2898 16.1673 19.2898C16.0048 19.2886 15.8438 19.2586 15.6916 19.2023V14.7086L15.6957 14.7076ZM15.6957 23.4726H14.2319V13.9533C14.8232 13.5908 15.5079 13.4095 16.2007 13.4336C17.9463 13.4336 18.9051 14.7586 18.9051 16.8883C18.9051 19.018 17.9719 20.4861 16.3432 20.4861C16.1207 20.4901 15.8988 20.4617 15.6844 20.4017V23.4689L15.6957 23.4726ZM9.10819 18.1695V13.5876H10.5719V18.2355C10.5719 18.6489 10.6707 19.2636 11.3438 19.2636C11.5841 19.2697 11.8209 19.2048 12.0244 19.077V13.5876H13.4882V19.9151C12.831 20.3245 12.0663 20.5289 11.2923 20.5008C9.8285 20.5008 9.09631 19.7176 9.09631 18.1658L9.10819 18.1695ZM8.37632 18.7586C8.31132 20.4648 9.04131 22.1042 10.3526 23.1976C11.4944 24.1308 15.0151 25.7226 16.0066 26.1583C16.9838 25.7264 20.4973 24.1526 21.6573 23.1976C22.9698 22.107 23.7001 20.4673 23.6335 18.762V9.07452C18.7401 8.6214 12.9544 8.89952 8.37257 13.1008V18.7586H8.37632Z",
				fill: "#351C15"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_68_10173",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white",
				transform: "translate(6 7)"
			})
		}) })
	]
});
export default SvgUps;
